import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import { criarCadastroModelosPrefeitura } from "../../DataSources";
import ShowError from "../../AppServices";
import api from "../../api-axios";

const template = {
  id: undefined,
  prefeituraId: undefined,
  nome: "",
  titulo: "",
  tipoValidacao: "",
  legendaCampo1: "",
  instrucaoCampo1: "",
  legendaCampo2: "",
  instrucaoCampo2: "",
  legendaCampo3: "",
  instrucaoCampo3: "",
};

export default class CadastroModelosPrefeituraForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { fieldsAmount: 1 };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.criarCadastroModelos = criarCadastroModelosPrefeitura();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);

    this.fieldsAmountOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [1, 2, 3],
      onValueChanged: (e) => this.setState({ fieldsAmount: e.value }),
    };
  }

  componentDidMount() {
    const model = this.props.match.params.id;
    console.log("mode: ", model);
    if (model !== undefined) {
      api
        .get(`validacao_documentos/buscar_tipo/${model}`)
        .then(({ data }) => {
          if (!data) {
            notify("Modelo não encontrado.", "error");
            this.props.history.push("/cadastro-modelos-prefeitura");
          }
          console.log(data);
          this.setState(data[0]);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    } else {
      notify("Modelo não encontrado.", "error");
      this.props.history.push("/cadastro-modelos-prefeitura");
    }

    if (model === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2} labelLocation="top">
          <GroupItem caption="Cadastro de Modelos" colSpan={2} colCount={3}>
            <SimpleItem dataField={"titulo"}>
              <Label text="Título" />
            </SimpleItem>
            <EmptyItem colSpan={2} />
            <SimpleItem dataField={"legendaCampo1"}>
              <Label text="Legenda do Campo 1" />
            </SimpleItem>
            <SimpleItem dataField={"instrucaoCampo1"} colSpan={2}>
              <Label text="Instrução do Campo 1" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo2"}
              visible={this.state.qtdeCampos >= 2}
            >
              <Label text="Legenda do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo2"}
              visible={this.state.qtdeCampos >= 2}
              colSpan={2}
            >
              <Label text="Instrução do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo3"}
              visible={this.state.qtdeCampos === 3}
            >
              <Label text="Legenda do Campo 3" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo3"}
              visible={this.state.qtdeCampos === 3}
              colSpan={2}
            >
              <Label text="Instrução do Campo 3" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  async ok() {
    try {
      const entidade = this.state;
      const modelId = this.props.match.params.id;
      const response = await api.put(
        `validacao_documentos/editar_tipo/${modelId}`,
        entidade
      );

      if (response && response.status === 200) {
        notify("Modelo cadastrado com sucesso.", "success");
        this.props.history.goBack();
      }
    } catch (error) {
      if (error.response) {
        ShowError(error.response.data);
      }
      notify(error, "error", 2000);
    }
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
